export default __webpack_public_path__ + "static/lol-screen-a059175c798bdf350b9868cac792b62a.png";